import {Component, OnInit} from '@angular/core';
import {CarouselModule} from '@coreui/angular';
import {CommonModule, NgFor} from '@angular/common';
import {RouterLink} from '@angular/router';
import {
    CarouselCaptionComponent,
    CarouselComponent,
    CarouselControlComponent,
    CarouselIndicatorsComponent,
    CarouselInnerComponent,
    CarouselItemComponent
} from '@coreui/angular';
import {PageTitleComponent} from './components/page-title/page-title.component';
import {ParallaxStandaloneDirective} from '@yoozly/ngx-parallax';
import {OnscrollAnimatedDirective} from '@/directives/onscroll/onscroll-animated.directive';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {
    constructor() {}
    slides: any[] = new Array(3).fill({
        id: -1,
        src: '',
        title: '',
        color: '',
        percentage: 0
    });
    planedSlides: any[] = [
        {
            title: 'مخططات جاري العمل',
            percentage: 72,
            color: '#4F6362'
        },
        {
            title: 'مخططات تم اطلاقها',
            percentage: 72,
            color: '#44BBB7'
        },
        {
            title: 'المناطق غير المخططة',
            percentage: 72,
            color: '#6CBE4A'
        },
        {
            title: 'عدد المخططات الابتدائية',
            percentage: 72,
            color: '#02947F'
        },
        {
            title: 'عدد المخططات الكلي ',
            percentage: 72,
            color: '#005E50'
        }
    ].reverse();
    reportedSlides: any[] = [
        {
            title: 'حاله المخطط رقم 1 ',
            link: ''
        },
        {
            title: 'حالة المخطط رقم 2',
            link: ''
        },
        {
            title: 'حالة المخطط رقم 3',
            link: ''
        },
        {
            title: 'حالة المخطط رقم 4',
            link: ''
        }
    ];

    ngOnInit(): void {
        this.slides[0] = {
            id: 0,
            src: './assets/images/76f533b519babe42c3125b8af67989c4.jfif',
            title: ' نحن نعمل لتطيب لكم الحياة في المدينة المنورة'
        };
        this.slides[1] = {
            id: 1,
            src: './assets/images/92308e2fec3bd019b95eac26741127dd.jfif',
            title: 'قال رسول الله صلي الله عليه و سلم “ المدينة خير لهم لو كانوا يعلمون.. “'
        };
        this.slides[2] = {
            id: 2,
            src: './assets/images/b849a41708fba0121f4ec116a5a381db.jfif',
            title: 'مشروع تصحيح و تحديث المخططات التفصيلية و التنظيمية بالمدينة المنورة'
        };
    }
}
